import type {
  CreateHealthCareFacilityPayload,
  CreateHealthCareFacilityResponse,
  DeleteHealthCareFacilityResponse,
  HealthCareFacilityDetailResponse,
  HealthCareFacilityDropdownResponse,
  HealthCareFacilityID,
  HealthCareFacilityListResponse,
  UpdateHealthCareFacilityParams,
  UpdateHealthCareFacilityPayload,
  UpdateHealthCareFacilityResponse,
} from '@/domains/asset-management/types/healthcare';
import { APIS, URLS } from '@/shared/config/urls';
import { request } from '@/shared/utils/request';

const toUrlID = (id: string | number): string => String(id);

export const fetchHealthCareFacilityList = async (
  params: string = ''
): Promise<HealthCareFacilityListResponse> => {
  const url = `${URLS.BACK_DSH}${APIS.healthCareFacilityManagementList(params)}`;
  return await request.get(url);
};

export const fetchDetailHealthCareFacility = async (
  id: HealthCareFacilityID
): Promise<HealthCareFacilityDetailResponse> => {
  const url = `${URLS.BACK_DSH}${APIS.detailHealthCareFacilityManagement(toUrlID(id))}`;
  return await request.get(url);
};

export const deleteHealthCareFacility = async (
  id: HealthCareFacilityID
): Promise<DeleteHealthCareFacilityResponse> => {
  const url = `${URLS.BACK_DSH}${APIS.deleteHealthCareFacilityManagement(toUrlID(id))}`;
  return await request.delete(url);
};

export const createHealthCareFacility = async (
  data: CreateHealthCareFacilityPayload
): Promise<CreateHealthCareFacilityResponse> => {
  const url = `${URLS.BACK_DSH}${APIS.createHealthCareFacilityManagement}`;
  return await request.post(url, data);
};

export const updateHealthCareFacility = async (
  data: UpdateHealthCareFacilityPayload,
  params: UpdateHealthCareFacilityParams
): Promise<UpdateHealthCareFacilityResponse> => {
  const url = `${URLS.BACK_DSH}${APIS.updateHealthCareFacilityManagement(toUrlID(params.health_care_facility_id))}`;
  return await request.put(url, data);
};

// (health_care_facility_id, name) dropdown pairs - reused by AmbulanceManagement's
// health_care_facility_id select.
export const fetchHealthCareFacilityDropdownList = async (
  params: string = ''
): Promise<HealthCareFacilityDropdownResponse> => {
  const url = `${URLS.BACK_DSH}${APIS.healthCareFacilityDropdownList(params)}`;
  return await request.get(url);
};
